import { useEffect, useState } from "react";
import { useRef } from "react";
import { motion } from "framer-motion";

// * React icons
import { useMediaQuery } from "react-responsive";
import { IoIosArrowBack } from "react-icons/io";
import { MdMenu } from "react-icons/md";
import { NavLink, useLocation } from "react-router-dom";
import BtnAddTask from "../../Utilities/BtnAddTask";
import NavLinks from "../NavLinks";
import { menusActions } from "../../../store/Menu.store";
import { useDispatch } from "react-redux";

const SideBar = (props) => {
  let isTabletMid = useMediaQuery({ query: "(max-width: 640px)" });
  const [open, setOpen] = useState(isTabletMid ? false : true);
  const sidebarRef = useRef();
  const { pathname } = useLocation();
  const classLinkActive =
    "bg-[#50CAFF] border-r-4 border-[#E4EFF9]  bold text-[#1D1E22]";

  useEffect(() => {
    if (isTabletMid) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [isTabletMid]);

  useEffect(() => {
    isTabletMid && setOpen(false);
  }, [pathname]);

  const Nav_animation = isTabletMid
    ? {
        open: {
          x: 0,
          width: "16rem",
          transition: {
            damping: 40,
          },
        },
        closed: {
          x: -250,
          width: 0,
          transition: {
            damping: 40,
            delay: 0.15,
          },
        },
      }
    : {
        open: {
          width: "16rem",
          transition: {
            damping: 40,
          },
        },
        closed: {
          width: "4rem",
          transition: {
            damping: 40,
          },
        },
      };

  return (
    <div>
      <div
        onClick={() => setOpen(false)}
        className={`md:hidden fixed inset-0 max-h-screen   ${
          open ? "block" : "hidden"
        } `}
      ></div>
      <motion.div
        ref={sidebarRef}
        variants={Nav_animation}
        initial={{ x: isTabletMid ? -250 : 0 }}
        animate={open ? "open" : "closed"}
        className="  text-gray shadow-xl  max-w-[16rem]  
            overflow-hidden  
            fixed bg-[#292B32]  top-0 left-0  w-64  transition-transform -translate-x-full sm:translate-x-0
         h-screen "
      >
        <NavLink to="/">
          <div className="flex items-center gap-2.5  py-3  mx-3">
            <svg
              width="252"
              height="34"
              viewBox="0 0 252 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_1_1036)">
                <path
                  d="M67.4567 8.73499V24.0893H61.4036V8.73499H67.4567Z"
                  fill="#E4EFF9"
                />
                <path
                  d="M91.0954 8.73499V24.0893H84.7132L78.5722 15.7546V24.0893H72.5192V8.73499H78.8801L85.0423 17.0925V8.73499H91.0954Z"
                  fill="#E4EFF9"
                />
                <path
                  d="M116.383 8.73499L109.274 24.0893H102.406L95.2745 8.73499H101.547L105.839 19.5703L110.11 8.73499H116.383Z"
                  fill="#E4EFF9"
                />
                <path
                  d="M136.807 24.0893H120.564V8.73499H136.61V12.7051H126.617V14.4376H135.993V18.1884H126.617V20.1402H136.807V24.0893Z"
                  fill="#E4EFF9"
                />
                <path
                  d="M160.115 19.2212C160.115 23.279 156.505 24.4206 150.452 24.4206C143.497 24.4206 140.987 22.446 140.987 19.1126H147.305C147.305 20.2962 148.316 20.7136 150.805 20.7136C152.807 20.7136 153.666 20.4277 153.666 19.6825C153.666 18.8705 153.027 18.8705 148.163 18.2568C143.364 17.643 141.406 16.6119 141.406 13.4309C141.406 10.0536 144.267 8.42976 150.233 8.42976C156.791 8.42976 159.103 10.5358 159.103 13.4309H152.985C152.985 12.5542 152.213 12.114 150.191 12.114C148.167 12.114 147.394 12.5314 147.394 13.1661C147.394 13.9991 148.517 14.0658 151.312 14.3498C156.55 14.8759 160.115 15.1389 160.115 19.2195V19.2212Z"
                  fill="#E4EFF9"
                />
                <path
                  d="M181.353 12.7063H175.521V24.0906H169.467V12.7063H163.633V8.73625H181.351V12.7063H181.353Z"
                  fill="#E4EFF9"
                />
                <path
                  d="M205.981 16.4118C205.981 22.4213 200.743 24.4187 195.526 24.4187C190.307 24.4187 185.093 22.4231 185.093 16.4118C185.093 10.4006 190.31 8.42784 195.526 8.42784C200.74 8.42784 205.981 10.4234 205.981 16.4118ZM199.84 16.4118C199.84 13.9552 198.342 12.3541 195.526 12.3541C192.708 12.3541 191.21 13.9552 191.21 16.4118C191.21 18.8686 192.708 20.4925 195.526 20.4925C198.342 20.4925 199.84 18.8914 199.84 16.4118Z"
                  fill="#E4EFF9"
                />
                <path
                  d="M219.976 19.309H216.653V24.091H210.6V8.73499H222.176C226.623 8.73499 228.89 10.4026 228.89 13.9115C228.89 16.2806 227.678 17.7712 225.785 18.562L229.35 24.0893H222.968L219.975 19.3073L219.976 19.309ZM216.653 15.3828H220.879C222.177 15.3828 222.838 14.9654 222.838 13.9782C222.838 12.9909 222.177 12.7068 220.879 12.7068H216.653V15.3828Z"
                  fill="#E4EFF9"
                />
                <path
                  d="M252 19.2212C252 23.279 248.391 24.4206 242.337 24.4206C235.382 24.4206 232.873 22.446 232.873 19.1126H239.19C239.19 20.2962 240.202 20.7136 242.69 20.7136C244.692 20.7136 245.55 20.4277 245.55 19.6825C245.55 18.8705 244.912 18.8705 240.048 18.2568C235.25 17.643 233.292 16.6119 233.292 13.4309C233.292 10.0536 236.153 8.42976 242.118 8.42976C248.675 8.42976 250.988 10.5358 250.988 13.4309H244.87C244.87 12.5542 244.099 12.114 242.076 12.114C240.052 12.114 239.279 12.5314 239.279 13.1661C239.279 13.9991 240.403 14.0658 243.197 14.3498C248.435 14.8759 252 15.1389 252 19.2195V19.2212Z"
                  fill="#E4EFF9"
                />
                <path
                  d="M23.5243 33.9752L41.5621 0.0102234H52.1321L34.1119 33.9524C34.1119 33.9524 23.5384 33.9769 23.5225 33.9769L23.5243 33.9752Z"
                  fill="#06B4FF"
                />
                <path
                  d="M44.1962 18.9015L36.2182 33.9524H52.917L44.1962 18.9015Z"
                  fill="#06B4FF"
                />
                <path
                  d="M31.4812 15.0599L39.4594 0.00894165H22.7606L31.4812 15.0599Z"
                  fill="#06B4FF"
                />
                <path
                  d="M20.6527 0.00894165L2.61482 34.0001C2.62889 34.0001 13.2041 33.9757 13.2041 33.9757L26.169 9.5361L20.6527 0.00894165Z"
                  fill="#E4EFF9"
                />
                <path
                  d="M0 9.5289H26.0229L20.6526 0.00876785L5.05011 0L0 9.5289Z"
                  fill="#E4EFF9"
                />
              </g>
              <defs>
                <clipPath id="clip0_1_1036">
                  <rect width="252" height="34" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </NavLink>
        <div className="flex flex-col  h-full">
          <ul className="whitespace-pre px-2.5 text-[0.9rem] py-5 flex flex-col gap-1  font-medium overflow-x-hidden scrollbar-thin scrollbar-track-white scrollbar-thumb-slate-100   md:h-[68%] h-[70%]">
            {/* <ul className="space-y-2 "> */}
            <li>
              {/* <motion.div
                onClick={() => {
                  setOpen(!open);
                }}
                animate={
                  open
                    ? {
                        x: 0,
                        y: 0,
                        rotate: 0,
                      }
                    : {
                        x: -10,
                        y: -200,
                        rotate: 180,
                      }
                }
                transition={{ duration: 0 }}
                className="absolute w-fit h-fit md:block z-50 hidden right-2 bottom-3 cursor-pointer"
              >
                <IoIosArrowBack size={25} />
              </motion.div> */}
            </li>

            {props.isUserLoggedIn ? (
              <li>
                <div className="flex items-center">
                  <BtnAddTask className="my-3" />
                </div>
              </li>
            ) : null}
            <li>
              <NavLinks classActive={classLinkActive} />
            </li>
          </ul>
        </div>
        {/* <motion.div
          onClick={() => {
            setOpen(!open);
          }}
          animate={
            open
              ? {
                  x: 0,
                  y: 0,
                  rotate: 0,
                }
              : {
                  x: -10,
                  y: -200,
                  rotate: 180,
                }
          }
          transition={{ duration: 0 }}
          className="absolute w-fit h-fit md:block z-50 hidden right-2 bottom-3 cursor-pointer"
        >
          <IoIosArrowBack size={25} />
        </motion.div> */}
      </motion.div>
      <div className="m-3  md:hidden  " onClick={() => setOpen(true)}>
        <MdMenu size={25} />
      </div>
    </div>
  );
};

export default SideBar;
